import type { Wave5Ctx } from './EpcEstimateWave5Panels';

/** Project cost Control Center leaves → TEC bucket highlight. */
export type Est3ProjectCostLeafKey =
  | 'duration'
  | 'indirects'
  | 'risks'
  | 'contingency'
  | 'escalation'
  | 'fx';

export const EST3_PROJECT_COST_LEAVES: Est3ProjectCostLeafKey[] = [
  'duration',
  'indirects',
  'risks',
  'contingency',
  'escalation',
  'fx',
];

export interface Est3ProjectCostBucketDef {
  label: string;
  field: keyof Est3TecBuckets;
}

export interface Est3TecBuckets {
  total_estimated_cost?: number;
  direct_cost?: number;
  indirect_cost?: number;
  risk_allowance?: number;
  contingency?: number;
  escalation?: number;
  fx_allowance?: number;
  currency?: string;
  structure_pct?: Record<string, number>;
}

export const EST3_PROJECT_COST_BUCKET_MAP: Record<Est3ProjectCostLeafKey, Est3ProjectCostBucketDef> = {
  duration: { label: 'Indirect (duration-driven)', field: 'indirect_cost' },
  indirects: { label: 'Indirect', field: 'indirect_cost' },
  risks: { label: 'Risk Allowance', field: 'risk_allowance' },
  contingency: { label: 'Contingency', field: 'contingency' },
  escalation: { label: 'Escalation', field: 'escalation' },
  fx: { label: 'FX Allowance', field: 'fx_allowance' },
};

/** Indirect calc methods that depend on project duration. */
export const EST3_TIME_RELATED_INDIRECT_METHODS = [
  'MONTHLY_X_DURATION',
  'RESOURCE_X_DURATION',
] as const;

export type Est3RevisionCtx = Wave5Ctx;
